import { NavLink } from "react-router-dom";
import logo from '../assets/images/DK.jpg'
import styled from "styled-components";

const Navbar = () => {

  return (
    <header className='header'>
      <NavLink to='/'>
        <Logo>DK</Logo>
      </NavLink>
      <nav className='flex text-lg gap-7 font-medium'>
        <NavLink to='/about' className={({ isActive }) => isActive ? "text-blue-600 font-bold" : "text-black font-bold" }>
          About
        </NavLink>
        <NavLink to='/projects' className={({ isActive }) => isActive ? "text-blue-600 font-bold" : "text-black font-bold"}>
          Projects
        </NavLink>
      </nav>
    </header>
  );
};

const Logo = styled.div`
  width: 60px;
  height: 60px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  font-weight: 800;
`
export default Navbar;
